import { promoimmoGeneratedEntity } from "./generated/promoimmoGeneratedEntity";

export abstract class promoimmoEntity extends promoimmoGeneratedEntity {
    // Comment to preserve new line
}
